
// mutations
const FORM = (state, form) => {
  state.form = form
}

export default {
  FORM
}



// WEBPACK FOOTER //
// ./src/store/modules/base/form/mutations.js